let html = `<div class="warning-box warning-box--{type}">
    <div class="warning-box__icon">{icon}</div>
    <div class="warning-box__content">
        <div class="warning-box__title">{title}</div>
        <div class="warning-box__descr">{text}</div>
    </div>
    <div class="warning-box__right hide"></div>
</div>`

export default html